import React from 'react';
import ContactForm from '../components/ContactForm';

const Contact = () => {
    return (
        <div className="contact-container">
            <h1>Let's Chat!</h1>
            <ContactForm />
        </div>
    );
};

export default Contact;